import React from 'react'
import {
  Wrapper,
  Content,
  Image,
  Information,
  Title,
  Text,
  List,
  Item
} from './SubscribedHeading.styles.js'
import Link from 'components/UI/Link'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { FormattedDate, FormattedMessage } from 'react-intl'
import TopBanner from '../TopBanner.js'

export default props => {
  if (props.subscription.custom) {
    return (
      <Wrapper>
        <Content>
          <Information>
            <Title>
              {new Date(props.subscription.subscriptionEndDate) > Date.now()
                ? 'Thank you'
                : ''}
            </Title>
            <p>
              {new Date(props.subscription.subscriptionEndDate) > Date.now() ? (
                <Text>
                  You're now a Night Zookeeper subscriber. Welcome to the
                  community!
                </Text>
              ) : (
                <Text>
                  <FormattedMessage
                    defaultMessage='Your custom subscription expired on {renewDate}.'
                    id='dashboard.customSubscriptionExpired'
                    values={{
                      renewDate: (
                        <FormattedDate
                          value={new Date(props.subscription.subscriptionEndDate)}
                          year='numeric'
                          month='long'
                          day='numeric'
                        />
                      )
                    }}
                  />
                </Text>
              )}
            </p>
            <p>
              {new Date(props.subscription.subscriptionEndDate) > Date.now() ? (
                <Text color={colors.success}>
                  <FormattedMessage
                    defaultMessage='You are on custom subscription plan which will renew on the {renewDate}.'
                    id='dashboard.customSubscriptionStatus.renewDate'
                    values={{
                      renewDate: (
                        <FormattedDate
                          value={new Date(props.subscription.subscriptionEndDate)}
                          year='numeric'
                          month='long'
                          day='numeric'
                        />
                      )
                    }}
                  />
                </Text>
              ) : (
                <Text color={colors.success}>
                  We'd love you to join the community for another year!
                </Text>
              )}
            </p>
            <p>
              <Text small>
                Any questions? Simply email{' '}
                <a href={'mailto:sales@nightzookeeper.com'}>
                  sales@nightzookeeper.com
                </a>
              </Text>
              <Text small>
                {' '}or click on the chat icon at the bottom right of the screen.
              </Text>
            </p>
          </Information>
          <Image src={`${ASSETS_PATH}/images/kids.jpeg`} />
        </Content>
      </Wrapper>
    )
  }
  if (new Date(props.subscription.subscriptionEndDate) < Date.now()) {
    return <TopBanner parent={props.parent} />
  }
  return (
    <Wrapper>
      <Content>
        <Information>
          <Title>Thank you</Title>
          <p>
            <Text>
              You're now a Night Zookeeper subscriber. Welcome to the community!
            </Text>
          </p>
          <p>
            <Text color={colors.success}>
              <FormattedMessage
                defaultMessage='You have a {productName} subscription which
          will renew on the {renewDate}.'
                id='dashboard.subscriptionStatus.active'
                values={{
                  productName: props.subscription.plan ? props.subscription.plan.product.name : '',
                  renewDate: (
                    <FormattedDate
                      value={props.subscription.subscriptionEndDate}
                      year='numeric'
                      month='long'
                      day='numeric'
                    />
                  )
                }}
              />
            </Text>
          </p>
          { /* <p>
            <Text>
              You currently have 10% discount applied to your subscription.
            </Text>
            <Text>
              Refer your friends and earn more discounts{' '}
              <Link to={'referral'}>here.</Link>
            </Text>
         </p> */ }
          <p>
            <Text small>
              Any questions? Simply email{' '}
              <a href={'mailto:sales@nightzookeeper.com'}>
                sales@nightzookeeper.com
              </a>
            </Text>
            <Text small>
              {' '}or click on the chat icon at the bottom right of the screen.
            </Text>
          </p>
        </Information>
        <Image src={`${ASSETS_PATH}/images/kids.jpeg`} />
      </Content>
    </Wrapper>
  )
}
